import { fetch } from 'wix-fetch';
export const ctaName = { home: 'home', templates: 'templates', all_features: 'all_features', request_access: 'request_access', tutorials: 'tutorials', start_now: 'start_now' }
export const ctaOrigin = { top_bar: 'top_bar', footer: 'footer', body: 'body' };
const msid = 'b443c084-d2d2-4945-b073-3772c84beca5';

const baseUrl = 'https://frog.wix.com';
const appName = 'editor-x';

export function ctaClick({ pageName, pageUrl, action, origin, text }) {
	return sendBiRequest(appName, 110, 707, createQueryParams({ pageName, pageUrl, action, origin, text, msid }));
}

function createQueryParams(eventObject) {
	return Object.entries(eventObject).map((item, index) => `${item[0]}=${item[1]}`).join('&');
}

function sendBiRequest(name, src, eventId, queryParams) {
	return fetch(`${baseUrl}/${name}?src=${src}&evid=${eventId}${queryParams ? `&${encodeURI(queryParams)}` : ''}`, {
		method: 'GET',
		credentials: 'include',
		cache: 'no-store'
	}).then(res => res.status);
}
